<template>
    <div class="MaterialForm">
        <DashboardEditSection title="Information">
            <FormInput
                v-model="$v.name.$model"
                label="Name"
                :errors="$v.name.$error ? [
                    !$v.name.required && 'Material name is required',
                ] : null"
                required
            />
        </DashboardEditSection>
    </div>
</template>

<script>
import DashboardEditSection from '@/components/DashboardEditSection';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'MaterialForm',

    components: { DashboardEditSection },

    props: {
        isEditMode: { type: Boolean, default: false },
    },

    syncProps: [
        'name',
    ],

    validations: {
        name: {
            required,
        },
    },

    methods: {
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },
    },
}
</script>
